<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PmqYrY/tc-custom/9781399086431.jpg?1704299962756" alt="This image is the cover for the book McDonnell Douglas F-4 Phantom, FlightCraft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">McDonnell Douglas F-4 Phantom, FlightCraft
      </h1>
      <p class="bookDescription body article font2">
        <p>The McDonnell Douglas F-4 Phantom II was the most-produced American supersonic military jet with 5,195 aircraft being produced. By any standards the F-4 has been incredibly successful, used not only by the USAF and US Navy but many air forces around the world including Germany, Israel, Turkey and Japan.  The F-4 was designed as a long-range fighter interceptor and fighter bomber, excellent in all roles assigned to it. The Phantom has performed leading roles in multiple conflicts around the world from the Vietnam War through to the Gulf War. Although the F-4 left US service in 1996 it has continued in service with other air forces, only just being retired in 2020 from the Japanese Air Self-Defence Force.  This new title in Pen &amp; Sword's highly successful Flight Craft series covers the development and operational use of the F-4 Phantom II and brings to life the variety of color schemes and markings applied by many of the multiple air arms that have operated the Phantom around the world by including quality color profiles.  Multiple model projects are included covering significant variants of the F-4 like the F-4B, F-4D, F-4E, F-4F, F-4G, F-4J, F-4EJ-Kai; British FGR-2 and F-4J(UK). All the popular model scales are represented: 1:72, 1:48 and 1:32A first for scale modellers everywhere – a book aimed at scale modellers of all levels interested in building the F-4 Phantom II.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoff Coughlin
      </h2>
      
      <p class="authorDescription body article">Geoff Coughlin is the founder and editor of a web-based scale modelling magazine, dedicated to helping scale modellers across the globe develop their skills. He is also author of eight titles on scale modelling and an aviation history enthusiast.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64e97c27